import { render, staticRenderFns } from "./OperationRender.vue?vue&type=template&id=9a36b214&"
import script from "./OperationRender.vue?vue&type=script&lang=js&"
export * from "./OperationRender.vue?vue&type=script&lang=js&"
import style0 from "./OperationRender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a36b214')) {
      api.createRecord('9a36b214', component.options)
    } else {
      api.reload('9a36b214', component.options)
    }
    module.hot.accept("./OperationRender.vue?vue&type=template&id=9a36b214&", function () {
      api.rerender('9a36b214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/OperationRender.vue"
export default component.exports